var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForumKnowMoreModalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 0H2.33333C1.05 0 0 1.05 0 2.33333V10.5C0 11.7833 1.05 12.8333 2.33333 12.8333H18.6667C19.95 12.8333 21 11.7833 21 10.5V2.33333C21 1.05 19.95 0 18.6667 0ZM2.33333 8.16667H5.985C6.23 9.07667 6.76667 9.88167 7.46667 10.5H2.33333V8.16667ZM18.6667 10.5H13.5333C14.2333 9.88167 14.77 9.07667 15.015 8.16667H18.6667V10.5ZM18.6667 5.83333H12.8333V7C12.8333 8.24833 11.7483 9.33333 10.5 9.33333C9.25167 9.33333 8.16667 8.24833 8.16667 7V5.83333H2.33333V2.33333H18.6667V5.83333ZM16.3333 14H12.8333V15.1667C12.8333 15.715 12.6117 16.2167 12.2733 16.625C11.8417 17.15 11.2 17.5 10.5 17.5C9.8 17.5 9.15833 17.15 8.72667 16.625C8.38833 16.2167 8.16667 15.715 8.16667 15.1667V14H0V18.6667C0 19.95 1.05 21 2.33333 21H18.6667C19.95 21 21 19.95 21 18.6667V14H16.3333ZM2.33333 16.3333H5.985C6.00833 16.4383 6.055 16.5317 6.09 16.625C6.37 17.4183 6.84833 18.1183 7.46667 18.6667H2.33333V16.3333ZM18.6667 18.6667H13.5333C14.1633 18.1183 14.6417 17.4183 14.91 16.625C14.945 16.5317 14.9917 16.4383 15.015 16.3333H18.6667V18.6667Z",
    fill: "#0662C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumKnowMoreModalicon);
export default __webpack_public_path__ + "static/media/ForumKnowMoreModalicon.db3c9766796e6b44c848704a510c96e5.svg";
export { ForwardRef as ReactComponent };